import script from "./InstagramLiveReportSharedWithMeLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramLiveReportSharedWithMeLayout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__